module.exports = __webpack_public_path__ + "media/icons/naped-tyl-active@2x-3dc93f3f.png";